import api from '../axios';

export const GET_ALL_SETTINGS = 'GET_ALL_SETTINGS'

export const getAllSettings = (token) => (dispatch) => {
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ` + token,
        },
    };
    return api.get('/settings', options)
        .then((response) => {
            dispatch({ type: GET_ALL_SETTINGS, payload: response.data})
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}
